import React from "react";
import PropTypes from "prop-types";
import ReactHighstock from "react-highcharts/ReactHighstock.src";

import chartConfig from "./chart.config";

const CoreChart = props => {
  return (
    <div className={`cp-core-chart ${props.className}`}>
      <ReactHighstock config={chartConfig(props)} />
    </div>
  );
};

CoreChart.propTypes = {
  className: PropTypes.string,
  chartWidth: PropTypes.number,
  chartHeight: PropTypes.number,
  chartTitle: PropTypes.string,
  chartSubTitle: PropTypes.string,
  xAxisLabel: PropTypes.string,
  // yAxisLabel: string,
  series: PropTypes.array.isRequired,
  yAxes: PropTypes.array.isRequired,
  legend: PropTypes.object,
  showLegend: PropTypes.bool.isRequired,
  isTooltipSplit: PropTypes.bool.isRequired
};

export default CoreChart;



// WEBPACK FOOTER //
// ./src/views/core/core_report_chart/core_chart/CoreChart.jsx